import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import HomeJunctionHomeTypeAppResource from "./HomeJunctionHomeTypeAppResource";

export const SINGLE_FAMILY_HOUSE = '095ab9ad-4c5a-40f0-8b9d-cb18fb7c0097';
export const CONDO = '8a50cd09-0a55-4d8a-b87a-1bf67c99e00e';
export const TOWNHOME = 'd1f6853b-7c79-4e2e-88ab-4288be47962b';
export const MULTI_FAMILY = 'b6a88a75-146b-4f9e-9a7c-80773a832518';
export const LAND = 'c3963459-62ba-45de-bf23-103875a1d051';
export const MOBILE_MANUFACTURED = '0b45558a-752b-473f-a48b-9687948e7b72';
export const OTHER = '78c3d98e-06bf-4409-99b5-8c7d8acfeb7b';
export const HOUSE = '095ab9ad-4c5a-40f0-8b9d-cb18fb7c0097';

export const ALL = {
    SINGLE_FAMILY_HOUSE,
    CONDO,
    TOWNHOME,
    MULTI_FAMILY,
    LAND,
    MOBILE_MANUFACTURED,
    OTHER,
    HOUSE,
};

class LuHomeTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-home-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/homes/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'meta',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            homeJunctionHomeTypes: HomeJunctionHomeTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            meta: {
                type: 'array'
            },
        };
    }

}

export default LuHomeTypeAppResource;
